import _get from 'lodash/get';
import urlResource from '../constants/UrlResources';
import { getPageUrlInfoFromLocation } from '../../lib/location-helper';
import * as Page from '../../lib/page';

// Actions
import fetchTopicTree from './action-topic-list';
import getPopularQuestions from './action-popular-list';
import { fetchQueryParams } from '../../contactUs/actions/action-query-params';
import { clearSuggestions } from '../../contactUs/actions/action-auto-complete';
import { fetchArticleSearchResult } from '../../contactUs/actions/action-article-search';
import getArticleListByTopic from './actions-article-list';
import fetchArticleContent from './action-article-content';
import { getHelpCenterAlerts } from '../../contactUs/actions/index';
import { resetToggleRelated } from '../../contactUs/actions/action-content-toggle';
import { resetBreadcrumb, updateBreadCrumbFromArticleContent } from '../actions/action-breadcrumb';
import { fetchMachineArticle } from '../actions/action-machine-article';

const experienceList = {
  personal: 'consumer',
  business: 'merchant',
  premier: 'consumer',
  technical: 'merchant', // TODO: update technical experience
};

// Compare with previous state to reduce data loading times
function isLocationOutOfSyncWithState(location, state) {
  return location.pathname !== state.location.pathname;
}

function isTopicTreeOutOfSyncWithState(location, state) {
  const pageInfo = getPageUrlInfoFromLocation(location);
  return pageInfo.experience !== state.topicList.experience;
}
function isPopularListOutOfSyncWithState(state) {
  return state.popular.articles && state.popular.articles.length <= 0;
}
function isTopicListOutOfSyncWithState(location, state) {
  const pageInfo = getPageUrlInfoFromLocation(location);
  return (pageInfo.experience !== state.location.experience || pageInfo.resource.id !== state.articleList.articleId);
}

function isArticleSyncOutOfWithState(location, state) {
  const pageInfo = getPageUrlInfoFromLocation(location);
  const stateArticleId = _get(state, 'article.article.articleId');
  return (pageInfo.experience !== state.location.experience || pageInfo.resource.id !== stateArticleId);
}

function isSearchSyncOutOfWithState(location, state) {
  const pageInfo = getPageUrlInfoFromLocation(location);
  return (pageInfo.experience !== state.location.experience || pageInfo.resource.searchTerm !== state.searchResult.q
    || pageInfo.resource.channelOption !== state.searchResult.channel);
}

function updateRouteState(location) {
  return {
    type: 'LOCATION_CHANGE',
    payload: { location },
  };
}

function getWebAlert({ dispatch, resource }) {
  // Check if its Home Page and pass `true` to return all the alerts.
  if (resource.name === urlResource.HOME) {
    dispatch(getHelpCenterAlerts(true));
    dispatch(resetToggleRelated());
    dispatch(resetBreadcrumb());
  } else {
    dispatch(getHelpCenterAlerts(false));
  }
}

function routeDidUpdate(location) {
  return (dispatch, getState) => {
    const state = getState();
    const experience = Page.getUserExperience();
    const pageInfo = Object.assign({}, location, { experience });

    const pageUrlInfo = getPageUrlInfoFromLocation(pageInfo);
    const { resource } = pageUrlInfo;

    if (isLocationOutOfSyncWithState(pageInfo, state)) {
      dispatch(updateRouteState(pageInfo));

      // Check path change for updating web alerts
      getWebAlert({ dispatch, resource });
    }

    if (resource.name === urlResource.HOME && isPopularListOutOfSyncWithState(state)) {
      dispatch(getPopularQuestions(experience));
      dispatch(resetToggleRelated());
    }
    if (resource.name === urlResource.HOME && isTopicTreeOutOfSyncWithState(pageInfo, state)) {
      dispatch(fetchTopicTree(experience));
      dispatch(resetToggleRelated());
    }

    if (resource.name === urlResource.TOPIC && isTopicListOutOfSyncWithState(pageInfo, state)) {
      dispatch(getArticleListByTopic(resource.id, experience));
      dispatch(resetToggleRelated());
    }

    // To update the breadcrumbs on location change.
    if (resource.name === urlResource.ARTICLE && state.article && state.article.article !== undefined) {
      dispatch(updateBreadCrumbFromArticleContent(state.article.article));
    }

    if (resource.name === urlResource.ARTICLE && isArticleSyncOutOfWithState(pageInfo, state)) {
      dispatch(fetchArticleContent(experience, resource.id));

      // Request Machine Translation localized article content
      if (Page.isMachineTranslation()) {
        dispatch(fetchMachineArticle({ faqId: resource.id, locale: Page.getMachineTranslationMarket() }));
      }
    }

    if (resource.name === urlResource.SEARCH && isSearchSyncOutOfWithState(pageInfo, state)) {
      const q = resource.searchTerm;
      let channel = Page.getChannel(resource.channelOption);

      // Update SWS channel to fire API
      if (state.searchFilters && !state.searchFilters.formUpdated && !q) {
        channel = 'product';
      // passing MTS channel, if the user not make selection, has technical experience and no channel in the url
      } else if (state.searchFilters && !state.searchFilters.formUpdated && Page.isTechnicalExp() && !resource.channelOption) {
        channel = 'mts';
      }

      dispatch(clearSuggestions());
      dispatch(fetchQueryParams({
        q,
        channel,
      }));

      if (resource.searchTerm) {
        dispatch(fetchArticleSearchResult(resource.searchTerm, experienceList[experience || 'personal'], channel));
      }
    }
  };
}

export default {
  routeDidUpdate,
};
